import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-column menu-column">
          <h4 className="footer-heading">Menu</h4>
          <nav className="footer-nav">
            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>

            <Link to="/shipping" onClick={toTop}>
              Shipping Policy
            </Link>
            <Link to="/returns" onClick={toTop}>
              Refund Policy
            </Link>
            <Link to="/privacy" onClick={toTop}>
              Privacy Policy
            </Link>
            <Link to="/terms" onClick={toTop}>
              Terms of Service
            </Link>
            <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
            <Link to="/faqs" onClick={toTop}>FAQs</Link>
          </nav>
        </div>

        <div className="footer-column newsletter-column">
          <h4 className="footer-heading">Connect</h4>
          <div className="newsletter-content">
            <p><a href="mailto:zone@camartzuno.store">zone@camartzuno.store</a></p>
          </div>
        </div>

        <div className="footer-column social-column">
          <h4 className="footer-heading">camartzuno</h4>
          <p>Thoughtful food storage for everyday organization and meal prep.</p>
        </div>
      </div>
      <div className="footer-payments" aria-label="Supported payment methods">
        <span>Secure payments:</span>
        <strong>VISA</strong><strong>Mastercard</strong><strong>American Express</strong>
        <strong>Apple Pay</strong><strong>Google Pay</strong>
      </div>
    </footer>
  );
}

export default Footer;
